<style>
.div-row {
  display: flex;
  justify-content: space-between; /* Distribuye los elementos con espacio entre ellos */
}
.span-right {
  text-align: right; /* Alinea el texto a la derecha dentro del span */
}
.div-total {
  font-weight: bold;
  font-size: 18px;
  color: black;
}
.div-header {
  font-weight: bold;
  font-size: 16px;
  color: black;
  margin-left: 30px;
}
.div-card {
  font-weight: bold;
  font-size: 14px;
  color: gray;
  margin-left: 90px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab">Reporte diario de operaciones</b-card-header> -->
      <b-card-body>
        <div v-if="Show.SearchAdvance" style="margin-left:280px">
          <div class="col-md-4" v-if="ShowSearch.AdvancedSearch">
            <label>Fecha Desde</label>
            <br />
            <KitsDate v-model="Model.FechaDesde" :currentValue="Model.FechaDesde" />
          </div>

          <div class="col-md-4" v-if="ShowSearch.AdvancedSearch" style="margin-top: 20px">
            <label>Fecha Hasta</label>
            <br />
            <KitsDate v-model="Model.FechaHasta" :currentValue="Model.FechaHasta" />
          </div>

          <div class="col-md-4" v-if="ShowSearch.PreviousMonths">
            <label>Año</label>
            <br />
            <KitsCombo v-model="Year" v-bind:items="Years" propertyName="Value" propertyID="Value"></KitsCombo>
          </div>

          <div class="col-md-4" v-if="ShowSearch.PreviousMonths" style="margin-top: 20px">
            <label>Mes</label>
            <br />
            <KitsCombo
              v-model="Month"
              v-bind:items="Months"
              propertyName="Name"
              propertyID="EntityID"
            ></KitsCombo>
          </div>

          <div class="col-md-4" style="margin-top: 20px">
            <label>Tipo Impuesto</label>
            <br />
            <KitsCombo
              v-model="Model.TipoImpuestoID"
              v-bind:items="TiposImpuestos"
              propertyName="Name"
              propertyID="EntityID"
              :todos="true"
            ></KitsCombo>
          </div>

          <br />

          <div class="col-md-4">
            <label>Detallado</label>
            <input type="checkbox" id="chkDetallado" name="chkDetallado" v-model="Model.Detallado" />
          </div>
        </div>

        <div v-if="Show.SearchAdvance" style="margin-left:270px;margin-top: 40px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>

            <b-button class="btn btn-success" @click="btnExportClick()">Descargar</b-button>
            <b-button
              class="btn btn-success"
              style="background-color: rgb(94, 114, 228); border: 2px solid rgb(94, 114, 228);"
              @click="btnClickFind()"
              :disabled="Model.Detallado"
            >Buscar</b-button>
          </div>
        </div>

        <div v-if="this.Show.Report">
          <div
            class="text-center"
            style="font-weight: bold; font-size: 16px; margin-bottom: 40px;"
          >{{Titulo}}</div>
          <div class="col-md-8" style="margin-left:100px">
            <div class="div-row div-total" style="border-bottom: 1px solid #d6d4d4;">
              <span>TOTALES</span>
            </div>
            <div class="div-row div-total">
              <span>Base Imponible</span>
              <span class="span-right">$ {{Report.FormatedTotalTaxBase}}</span>
            </div>
            <div class="div-row div-total">
              <span>Importe Retenido</span>
              <span class="span-right">$ {{Report.FormatedTotalAmountReteined}}</span>
            </div>
            <div class="div-row div-total">
              <span>Importe Devuleto</span>
              <span class="span-right">$ {{Report.FormatedTotalAmountRefunded}}</span>
            </div>

            <div
              class="div-card"
              v-for="itemDetail in Report.Items"
              v-bind:key="itemDetail.TaxTypeID"
            >
              <div
                style="border-bottom: 1px solid #d6d4d4; margin-top:20px; margin-bottom:5px"
              >{{itemDetail.TaxDescripcion}}</div>
              <div class="div-row" style="color:black">
                <span>Total base imponible:</span>
                <span class="span-right">${{itemDetail.FormatedTotalTaxBase}}</span>
              </div>
              <div class="div-row" style="color:black">
                <span>Total importe retenido:</span>
                <span class="span-right">${{itemDetail.FormatedTotalAmountReteined}}</span>
              </div>
              <div class="div-row" style="color:black">
                <span>Total importe devuelto:</span>
                <span class="span-right">${{itemDetail.FormatedTotalAmountRefunded}}</span>
              </div>
            </div>

            <div class="col-md-12 text-left" style="margin-top: 20px">
              <b-button class="btn btn-danger" @click="goBack()">
                <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
              </b-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import store from "@/store";
import axiosHelpers from "@/helpers/axiosHelpers";
import DateTime from "luxon/src/datetime.js";
import KitsDate from "@/components/KitsDate";
import KitsCombo from "@/components/KitsCombo";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import fileHelpers from "@/helpers/fileHelpers";

export default {
  components: { KitsDate, KitsCombo },
  props: {
    SearchIDProp: Number
  },
  data() {
    return {
      SearchID: this.SearchIDProp,
      Model: {
        FechaDesde: null,
        FechaHasta: null,
        TipoImpuestoID: null,
        Detallado: false
      },
      TiposImpuestos: [],
      Years: [],
      Months: [],
      AllMonths: [],
      CurrentYearMonths: [],
      Year: null,
      Month: null,

      Show: {
        SearchAdvance: true,
        Report: false
      },

      ShowSearch: {
        PreviousMonths: false,
        AdvancedSearch: true
      },

      Report: null
    };
  },
  methods: {
    goBack() {
      let context = this;

      context.$router.push({
        name: "ReporteImpuestosSearchDates"
      });
    },
    InitializeDates() {
      let context = this;
      var dt = DateTime.local().plus({ days: -2 });
      var fecDesde = DateTime.local(dt.year, dt.month, dt.day, 0, 0).toString();

      context.Model.FechaDesde = fecDesde;
      context.Model.FechaHasta = datetimeHelpers.getNextDay();
    },
    showSearchAdvance() {
      let context = this;

      context.Model.TipoImpuestoID = null;

      if (context.SearchID == 1) {
        context.SelectSearch(true, false);
      } else if (context.SearchID == 2) {
        context.SelectSearch(false, true);
      }
    },
    SelectSearch(PreviousMonths, AdvancedSearch) {
      let context = this;
      context.ShowSearch.PreviousMonths = PreviousMonths;
      context.ShowSearch.AdvancedSearch = AdvancedSearch;
    },
    btnExportClick() {
      let context = this;

      if (context.Model.Detallado) {
        context.GetTaxesReportDetailedForReportViewer();
      } else {
        context.GetTaxesReportForReportViewer(true);
      }
    },
    btnClickFind() {
      let context = this;

      context.GetTaxesReportForReportViewer(false);
    },
    InitializeSearchDates() {
      let context = this;

      axiosHelpers.axiosGet(
        "DailyOperationsReport/GetTaxesReportViewerIndex",
        {},
        context,
        function(data) {
          context.TiposImpuestos = data.ResponseVM.TaxesTypes;

          context.Years = data.ResponseVM.YearItems;
          context.AllMonths = data.ResponseVM.MonthItems;
          context.Months = data.ResponseVM.MonthItems;

          context.InitilizeCurrentYearMonths(context);

          context.Year = DateTime.local().year;

          var NroMesAnterior = DateTime.local().month - 2;
          context.Month = context.Months[NroMesAnterior + 1].EntityID;

          context.showSearchAdvance();

          context.InitializeDates();
        }
      );
    },
    InitilizeCurrentYearMonths(context) {
      var ActualMonth = DateTime.local().month;
      context.Months.forEach(x => {
        if (x.EntityID <= ActualMonth) {
          context.CurrentYearMonths.push(x);
        }
      });
    },
    SetMonthsCombo(NewYearValue) {
      let context = this;
      if (DateTime.local().year == NewYearValue) {
        context.Months = context.CurrentYearMonths;
      } else {
        context.Months = context.AllMonths;
      }
    },
    GetTaxesReportDetailedForReportViewer() {
      let context = this;

      var req = {
        DateFrom: null,
        DateTo: null,
        TaxTypeID: context.Model.TipoImpuestoID
      };

      // -- Busqueda Meses Anteriores
      if (context.ShowSearch.PreviousMonths) {
        context.Titulo =
          "Reporte de Impuestos al " + context.Month + "-" + context.Year;

        var fechaDesde = DateTime.local(context.Year, context.Month, 1, 0, 0);
        var fechaHasta = fechaDesde.plus({ months: 1 });

        req.DateFrom = fechaDesde.toString().substring(0, 10);
        req.DateTo = fechaHasta.toString().substring(0, 10);
      }
      // -- Busqueda Avanzada
      else if (context.ShowSearch.AdvancedSearch) {
        if (context.Model.FechaDesde == "") {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Debe seleccionar una fecha desde",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        if (context.Model.FechaHasta == "") {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Debe seleccionar una fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        if (
          datetimeHelpers.compareFromTo(
            context.Model.FechaDesde,
            context.Model.FechaHasta
          )
        ) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La fecha desde debe ser anterior a la fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var fechaHoraActual = DateTime.local();
        var fechaActual = DateTime.local(
          fechaHoraActual.year,
          fechaHoraActual.month,
          fechaHoraActual.day,
          0,
          0
        );

        if (context.Model.FechaDesde == context.Model.FechaHasta) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La fecha desde debe ser anterior a la fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var DateTo = new Date(context.Model.FechaHasta.substring(0, 10));
        DateTo.setDate(DateTo.getDate());
        // if (DateTo >= fechaActual) {
        //   notificationHelpers.showWarning(
        //     "Advertencia!",
        //     "Solo se pueden filtrar las operaciones previas al día de hoy",
        //     context
        //   );
        //   context.Show.SearchAdvance = true;
        //   return;
        // }

        var cantidadDiasBusquedaAvanzada = 31;
        // if (
        //   datetimeHelpers.compareDifference(
        //     context.Model.FechaDesde,
        //     context.Model.FechaHasta,
        //     cantidadDiasBusquedaAvanzada
        //   )
        // ) {
        //   notificationHelpers.showWarning(
        //     "Advertencia!",
        //     "El rango de fechas ingresado no puede superar los " +
        //       cantidadDiasBusquedaAvanzada +
        //       " días",
        //     context
        //   );
        //   context.Show.SearchAdvance = true;
        //   return;
        // }

        var DateFrom = context.Model.FechaDesde.substring(0, 10);
        var DateTo = context.Model.FechaHasta.substring(0, 10);

        req.DateFrom = DateFrom;
        req.DateTo = DateTo;

        var DateToFormatted = new Date(DateTo.substring(0, 10));
        DateToFormatted.setDate(DateToFormatted.getDate());

        context.Titulo =
          "Reporte de operaciones desde " +
          DateFrom +
          " 00:00:00 hasta " +
          datetimeHelpers.getFormattedYYYYMMDD(DateToFormatted) +
          " 23:59:59";
      }

      req.Title = context.Titulo;

      axiosHelpers.axiosGet(
        "DailyOperationsReport/GetTaxesReportDetailedForReportViewer",
        req,
        context,
        function(data) {
          if (data.ResponseVM.Export.HasErrors == false) {
            var contentType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            fileHelpers.downloadFile(
              context,
              data.ResponseVM.Export.FileContent,
              data.ResponseVM.Export.FileName,
              contentType
            );
          }
        }
      );
    },
    GetTaxesReportForReportViewer(IsExport) {
      let context = this;

      var req = {
        DateFrom: null,
        DateTo: null,
        TaxTypeID: context.Model.TipoImpuestoID,

        IsExport: IsExport
      };

      // -- Busqueda Meses Anteriores
      if (context.ShowSearch.PreviousMonths) {
        context.Titulo =
          "Reporte de Impuestos al " + context.Month + "-" + context.Year;

        var fechaDesde = DateTime.local(context.Year, context.Month, 1, 0, 0);
        var fechaHasta = fechaDesde.plus({ months: 1 });

        req.DateFrom = fechaDesde.toString().substring(0, 10);
        req.DateTo = fechaHasta.toString().substring(0, 10);
      }
      // -- Busqueda Avanzada
      else if (context.ShowSearch.AdvancedSearch) {
        if (context.Model.FechaDesde == "") {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Debe seleccionar una fecha desde",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        if (context.Model.FechaHasta == "") {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Debe seleccionar una fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        if (
          datetimeHelpers.compareFromTo(
            context.Model.FechaDesde,
            context.Model.FechaHasta
          )
        ) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La fecha desde debe ser anterior a la fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var fechaHoraActual = DateTime.local();
        var fechaActual = DateTime.local(
          fechaHoraActual.year,
          fechaHoraActual.month,
          fechaHoraActual.day,
          0,
          0
        );

        if (context.Model.FechaDesde == context.Model.FechaHasta) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La fecha desde debe ser anterior a la fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var DateTo = new Date(context.Model.FechaHasta.substring(0, 10));
        DateTo.setDate(DateTo.getDate());
        // if (DateTo >= fechaActual) {
        //   notificationHelpers.showWarning(
        //     "Advertencia!",
        //     "Solo se pueden filtrar las operaciones previas al día de hoy",
        //     context
        //   );
        //   context.Show.SearchAdvance = true;
        //   return;
        // }

        var cantidadDiasBusquedaAvanzada = 31;
        // if (
        //   datetimeHelpers.compareDifference(
        //     context.Model.FechaDesde,
        //     context.Model.FechaHasta,
        //     cantidadDiasBusquedaAvanzada
        //   )
        // ) {
        //   notificationHelpers.showWarning(
        //     "Advertencia!",
        //     "El rango de fechas ingresado no puede superar los " +
        //       cantidadDiasBusquedaAvanzada +
        //       " días",
        //     context
        //   );
        //   context.Show.SearchAdvance = true;
        //   return;
        // }

        var DateFrom = context.Model.FechaDesde.substring(0, 10);
        var DateTo = context.Model.FechaHasta.substring(0, 10);

        req.DateFrom = DateFrom;
        req.DateTo = DateTo;

        var DateToFormatted = new Date(DateTo.substring(0, 10));
        DateToFormatted.setDate(DateToFormatted.getDate());

        context.Titulo =
          "Reporte de operaciones desde " +
          DateFrom +
          " 00:00:00 hasta " +
          datetimeHelpers.getFormattedYYYYMMDD(DateToFormatted) +
          " 23:59:59";
      }

      req.Title = context.Titulo;

      axiosHelpers.axiosGet(
        "DailyOperationsReport/GetTaxesReportForReportViewer",
        req,
        context,
        function(data) {
          if (data.Alerts.length == 0) {
            if (IsExport == false) {
              context.Report = data.ResponseVM.Report;

              context.Show.SearchAdvance = false;
              context.Show.Report = true;
            } else {
              if (data.ResponseVM.Export.HasErrors == false) {
                var contentType =
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                fileHelpers.downloadFile(
                  context,
                  data.ResponseVM.Export.FileContent,
                  data.ResponseVM.Export.FileName,
                  contentType
                );
              }
            }
          }
        }
      );
    }
  },
  beforeMount() {
    var context = this;
    this.InitializeSearchDates();
  },
  watch: {
    Year: function(newValue, oldValue) {
      this.SetMonthsCombo(newValue);
    }
  }
};
</script>